import React, { createContext, useContext, useState, useCallback } from 'react';

const LoadingContext = createContext();

export function LoadingProvider({ children }) {
    const [loadingCount, setLoadingCount] = useState(0);

    const startLoading = useCallback(() => {
        setLoadingCount(prev => prev + 1);
    }, []);

    const stopLoading = useCallback(() => {
        setLoadingCount(prev => Math.max(0, prev - 1));
    }, []);

    const isLoading = loadingCount > 0;

    return (
        <LoadingContext.Provider value={{ isLoading, startLoading, stopLoading }}>
            {children}
        </LoadingContext.Provider>
    );
}

export function useLoading() {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
}

// 전역 로딩 함수 (Context 외부에서 사용)
let globalStartLoading = () => {};
let globalStopLoading = () => {};

export function setGlobalLoadingFunctions(start, stop) {
    globalStartLoading = start;
    globalStopLoading = stop;
}

export function getGlobalLoadingFunctions() {
    return { startLoading: globalStartLoading, stopLoading: globalStopLoading };
}
